import React from "react";
import Template1 from "../CardsAndCertificates/CardTemplates/Template1";
import Template2 from "../CardsAndCertificates/CardTemplates/Template2";
import Template3 from "../CardsAndCertificates/CardTemplates/Template3";
import { URL } from "../../utils/Constants";
import { adToBsDate } from "../../utils/Utils";
import moment from "moment";

const ShowCardDetails = (props) => {
  const {
    cardDetails,
    userType,
    classOptionValue,
    schoolDetails,
    staffList,
    studentList,
    classValue,
  } = props;

  return (
    <>
      {staffList && userType.value === 2
        ? staffList?.map((value) => {
            return (
              <>
                {cardDetails?.map((items) => {
                  const emergencyContactName =
                    value?.people?.customTableFieldValues?.find(
                      (d) =>
                        d.customTableFieldName === "Emergency Contact Name",
                    )?.value;

                  const emergencyContactNumber =
                    value?.people?.customTableFieldValues?.find(
                      (d) =>
                        d.customTableFieldName === "Emergency Contact Number",
                    )?.value;
                  return (
                    <>
                      {items?.templateId === 1 ? (
                        <Template1
                          id={value?.id}
                          studentName={value?.people?.name}
                          subtitle={value.designations?.map(
                            (item) => item.name,
                          )}
                          schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                          schoolName={schoolDetails?.name}
                          schoolAddress={schoolDetails?.address}
                          // signature={items?.authorizedSignatureImagePath}
                          authorizedSignatureName={
                            items?.authorizedSignatureName
                          }
                          signature={
                            items?.authorizedSignatureImagePath
                              ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                              : ""
                          }
                          validityDate={adToBsDate(
                            moment(items?.validTill).format("YYYY-MM-DD"),
                          )}
                          schoolContact={schoolDetails?.phoneNumber}
                          schoolWebAddress={schoolDetails?.website}
                          userImage={
                            value?.photo
                              ? `${URL.imageSelectURL}${value?.photo}`
                              : ""
                          }
                          issuedDate={adToBsDate(
                            moment(items?.issueDate).format("YYYY-MM-DD"),
                          )}
                          emergencyContact={{
                            name: emergencyContactName || "",
                            contactNumber: emergencyContactNumber || "",
                          }}
                          mode={props?.mode}
                        />
                      ) : items.templateId === 2 ? (
                        <Template2
                          id={value?.id}
                          studentName={value?.people?.name}
                          subtitle={value.designations?.map(
                            (item) => item.name,
                          )}
                          schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                          schoolName={schoolDetails?.name}
                          schoolAddress={schoolDetails?.address}
                          // signature={items?.authorizedSignatureImagePath}
                          authorizedSignatureName={
                            items?.authorizedSignatureName
                          }
                          signature={
                            items?.authorizedSignatureImagePath
                              ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                              : ""
                          }
                          validityDate={adToBsDate(
                            moment(items?.validTill).format("YYYY-MM-DD"),
                          )}
                          schoolContact={schoolDetails?.phoneNumber}
                          schoolWebAddress={schoolDetails?.website}
                          userImage={
                            value?.photo
                              ? `${URL.imageSelectURL}${value?.photo}`
                              : ""
                          }
                          issuedDate={adToBsDate(
                            moment(items?.issueDate).format("YYYY-MM-DD"),
                          )}
                          emergencyContact={{
                            name: emergencyContactName || "",
                            contactNumber: emergencyContactNumber || "",
                          }}
                          mode={props?.mode}
                        />
                      ) : items.templateId === 3 ? (
                        <Template3
                          id={value?.id}
                          studentName={value?.people?.name}
                          subtitle={value.designations?.map(
                            (item) => item.name,
                          )}
                          schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                          schoolName={schoolDetails?.name}
                          schoolAddress={schoolDetails?.address}
                          // signature={items?.authorizedSignatureImagePath}
                          authorizedSignatureName={
                            items?.authorizedSignatureName
                          }
                          signature={
                            items?.authorizedSignatureImagePath
                              ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                              : ""
                          }
                          validityDate={adToBsDate(
                            moment(items?.validTill).format("YYYY-MM-DD"),
                          )}
                          schoolContact={schoolDetails?.phoneNumber}
                          schoolWebAddress={schoolDetails?.website}
                          userImage={
                            value?.photo
                              ? `${URL.imageSelectURL}${value?.photo}`
                              : ""
                          }
                          issuedDate={adToBsDate(
                            moment(items?.issueDate).format("YYYY-MM-DD"),
                          )}
                          emergencyContact={{
                            name: emergencyContactName || "",
                            contactNumber: emergencyContactNumber || "",
                          }}
                          userAddress={
                            value?.people?.peopleAddresses &&
                            (value.people.peopleAddresses?.[0]
                              ?.countryThirdLevelName ?? "") +
                              (value.people.peopleAddresses?.[0]
                                ?.countryThirdLevelName &&
                              value.people.peopleAddresses?.[0].countryName
                                ? ", "
                                : "") +
                              (value.people.peopleAddresses?.[0]?.countryName ??
                                "")
                          }
                          mode={props?.mode}
                        />
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
              </>
            );
          })
        : ""}
      {studentList && userType.value === 1
        ? studentList?.map((value) => {
            return (
              <>
                {cardDetails?.map((items) => {
                  return (
                    <>
                      {items?.templateId === 1 ? (
                        <Template1
                          id={value?.id}
                          studentName={value?.people?.name}
                          subtitle={classValue?.label}
                          schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                          schoolName={schoolDetails?.name}
                          schoolAddress={schoolDetails?.address}
                          // signature={items?.authorizedSignatureImagePath}
                          authorizedSignatureName={
                            items?.authorizedSignatureName
                          }
                          signature={
                            items?.authorizedSignatureImagePath
                              ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                              : ""
                          }
                          validityDate={adToBsDate(
                            moment(items?.validTill).format("YYYY-MM-DD"),
                          )}
                          schoolContact={schoolDetails?.phoneNumber}
                          schoolWebAddress={schoolDetails?.website}
                          userImage={
                            value?.people?.photo
                              ? `${URL.imageSelectURL}${value?.people?.photo}`
                              : ""
                          }
                          emergencyContact={
                            value?.studentContacts?.[0]?.contactPeople ?? ""
                          }
                          issuedDate={adToBsDate(
                            moment(items?.issueDate).format("YYYY-MM-DD"),
                          )}
                          mode={props?.mode}
                        />
                      ) : items.templateId === 2 ? (
                        <Template2
                          id={value?.id}
                          studentName={value?.people?.name}
                          subtitle={classValue?.label}
                          schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                          schoolName={schoolDetails?.name}
                          schoolAddress={schoolDetails?.address}
                          // signature={items?.authorizedSignatureImagePath}
                          authorizedSignatureName={
                            items?.authorizedSignatureName
                          }
                          signature={
                            items?.authorizedSignatureImagePath
                              ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                              : ""
                          }
                          validityDate={adToBsDate(
                            moment(items?.validTill).format("YYYY-MM-DD"),
                          )}
                          schoolContact={schoolDetails?.phoneNumber}
                          schoolWebAddress={schoolDetails?.website}
                          userImage={
                            value?.people?.photo
                              ? `${URL.imageSelectURL}${value?.people?.photo}`
                              : ""
                          }
                          emergencyContact={
                            value?.studentContacts?.[0]?.contactPeople ?? ""
                          }
                          issuedDate={adToBsDate(
                            moment(items?.issueDate).format("YYYY-MM-DD"),
                          )}
                          mode={props?.mode}
                        />
                      ) : items.templateId === 3 ? (
                        <>
                          <Template3
                            id={value?.id}
                            studentName={value?.people?.name}
                            subtitle={classValue?.label}
                            schoolLogo={`${URL.imageSelectURL}${schoolDetails?.imageName}`}
                            schoolName={schoolDetails?.name}
                            schoolAddress={schoolDetails?.address}
                            // signature={items?.authorizedSignatureImagePath}
                            authorizedSignatureName={
                              items?.authorizedSignatureName
                            }
                            signature={
                              items?.authorizedSignatureImagePath
                                ? `${URL.imageSelectURL}${items?.authorizedSignatureImagePath}`
                                : ""
                            }
                            validityDate={adToBsDate(
                              moment(items?.validTill).format("YYYY-MM-DD"),
                            )}
                            schoolContact={schoolDetails?.phoneNumber}
                            schoolWebAddress={schoolDetails?.website}
                            userImage={
                              value?.people?.photo
                                ? `${URL.imageSelectURL}${value?.people?.photo}`
                                : ""
                            }
                            emergencyContact={
                              value?.studentContacts?.[0]?.contactPeople ?? ""
                            }
                            issuedDate={adToBsDate(
                              moment(items?.issueDate).format("YYYY-MM-DD"),
                            )}
                            mode={props?.mode}
                            userAddress={
                              value?.people?.peopleAddresses &&
                              (value.people.peopleAddresses?.[0]
                                ?.countryThirdLevelName ?? "") +
                                (value.people.peopleAddresses?.[0]
                                  ?.countryThirdLevelName &&
                                value.people.peopleAddresses?.[0].countryName
                                  ? ", "
                                  : "") +
                                (value.people.peopleAddresses?.[0]
                                  ?.countryName ?? "")
                            }
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
              </>
            );
          })
        : ""}
    </>
  );
};
export default ShowCardDetails;
